export function displayPeerName(peer, fallback = '') {
    if (!peer)
        return fallback;
    const value = peer;
    const settings = value.contactSettings && typeof value.contactSettings === 'object'
        ? value.contactSettings
        : null;
    const remarkName = String(value.remarkName || settings?.remarkName || '').trim();
    if (remarkName)
        return remarkName;
    return String(value.name || value.nickname || value.id || fallback || '').trim() || fallback;
}
export function originalPeerNickname(peer, fallback = '') {
    if (!peer)
        return fallback;
    const value = peer;
    return String(value.nickname || value.name || value.id || fallback || '').trim() || fallback;
}
export function isPeerMuted(peer, now = Date.now()) {
    if (!peer)
        return false;
    const value = peer;
    const settings = value.contactSettings && typeof value.contactSettings === 'object'
        ? value.contactSettings
        : value;
    const muteMode = String(settings.muteMode || settings.mutedMode || 'none');
    if (muteMode === 'forever')
        return true;
    const mutedUntil = Number(settings.mutedUntil || 0);
    return Number.isFinite(mutedUntil) && mutedUntil > now;
}
//# sourceMappingURL=contacts.js.map